<template>
    <div
      class="floating-timer shadow rounded bg-white text-danger p-0"
      :style="styleObject"
    >
      <div class="d-flex flex-column align-items-center">
        <p class="display-6 mb-0">{{ formattedTime }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isRunning: true,
        elapsedTime: 0,
        interval: null,
        position: { x: window.innerWidth - 220, y: 20 }, // Default to top-right
      };
    },
    computed: {
      formattedTime() {
        const minutes = Math.floor(this.elapsedTime / 60).toString().padStart(2, "0");
        const seconds = (this.elapsedTime % 60).toString().padStart(2, "0");
        return `${minutes}:${seconds}`;
      },
      styleObject() {
        return {
          position: "fixed",
          top: `${this.position.y}px`,
          left: `${this.position.x}px`,
          // cursor: "grab",
          zIndex: 1050,
        };
      },
    },
    methods: {
      startTimer() {
        this.interval = setInterval(() => {
          this.elapsedTime++;
        }, 1000);
      },
    },
    mounted() {
      // Start the timer when the component is mounted
      this.startTimer();
    },
  };
  </script>
  
  <style scoped>
  .floating-timer {
    width: 200px;
    text-align: center;
  }
  </style>